import { ConnectorConfig } from '../../../models';
import { IsOptional, IsString } from 'class-validator';

export class ConnectorConfigAssetCollection extends ConnectorConfig {
	@IsString()
	target: string = '';

	@IsOptional()
	@IsString()
	assetPathProperty: string = 'assetPath';

	@IsOptional()
	@IsString()
	assetTitleProperty: string = 'title';
}
